import {Component, OnInit, ElementRef, ViewChild, Output, Injectable} from '@angular/core';
import {CaseService} from '../services/case.service';
import {Router, ActivatedRoute} from '@angular/router';
import {CasesForm} from '../models/data-model';
import {OwnersAdvanceSearch} from '../../owners/models/data-model';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
import {OwnerService} from '../../owners/services/owner.service';

@Component({
    selector: 'app-case-crud',
    templateUrl: '../views/case-crud.component.html',
    styleUrls: ['../css/case-crud.component.css']
})
export class CaseCrudComponent implements OnInit {
    @ViewChild('fileInput') fileInput: ElementRef;
    @ViewChild('fileInputClose') fileInputClose: ElementRef;

    public userId = sessionStorage.getItem("userId");
    public usrobj = JSON.parse(sessionStorage.getItem("user"));
    public userTZ = '';
    public noData: boolean = false;
    public Ownersdata: any;
    public make = "";
    public statusList: any;
    public priorityList: any;
    public caseSourceList: any;
    public dealerList: any;
    public caseTypeList: any;
    public assignToList: any;
    public categoryList: any;
    public subcategoryList: any;
    public subcategory2List: any;
    public dealerId = "";
    public categoryId = "";
    public subcategory1Id: any;
    public makeid: number;
    public makeList: any;
    public caseno = "";
    public errorMessage = "";
    public isSearchSubmit: boolean = false;
    public vehicleData: any;
    public showOwnerSearch: boolean = false;
    public advanceOwnerSearchfields = new OwnersAdvanceSearch("", null, null, null, null, "", null, null, null, 0, 10, false, "", "","",[],false);
    public casesForm = new CasesForm("", "", "", "", {}, null, {}, {
        id: null,
        companyName: "",
        firstName: "",
        lastName: "",
        phone: "",
        phoneTimeToCall: "",
        mobile: "",
        mobileTimeToCall: "",
        email: "",
        addressId: {
            id: null,
            address1: "",
            address2: "",
            city: "",
            postalCode: "",
            stateId: {
                id: null,
                stateCode: "",
                name: ""
            },
            countryId: {
                id: null,
                code: "",
                name: ""
            }
        }, optedIn: null,
        deleted: false,
        dateSynced: null,
        userId: null,
        assignedTo: {
            id: null,
            userName: "",
            firstName: "",
            lastName: ""
        }, dealerId: {
            id: "",
            superDealerCode: "",
            name: "",
            globalCode: "",
            localCode: "",
            regionCode: "",
            countryCode: ""
        },
        dateEntered: "",
        createdBy: {id: "", userName: "", firstName: "", lastName: "", leadNotification: "", caseNotification: "", notificationTime: ""},
        dateModified: "",
        modifiedBy: {id: "", userName: "", firstName: "", lastName: "", leadNotification: "", caseNotification: "", notificationTime: ""},
        vehicles: [{
            id: "",
            sugarVKey: "",
            individualId: "",
            vin: "",
            purchaseDate: "",
            cycle: {},
            salesType: {},
            vehicleType: {
                id: null,
                make: "",
                model: ""
            },
            year: "",
            dateEntered: "",
            createdBy: {id: "", userName: "", firstName: "", lastName: "", leadNotification: "", caseNotification: "", notificationTime: ""},
            dateModified: "",
            modifiedBy: {id: "", userName: "", firstName: "", lastName: "", leadNotification: "", caseNotification: "", notificationTime: ""},
            deleted: false,
            dateSynced: "",

        }]
    }, null, null, null, null, null, {}, {}, "", "", new Date(), null, new Date(), {}, new Date(), null, "", "", [{}]);
    public caseheadername = "CREATE CASE";
    submitted:boolean = false

    constructor(public _caseService: CaseService, public _ownerService: OwnerService, public _router: Router, public activeroute: ActivatedRoute, private _globalService: GlobalDataService) {this.userTZ = this._globalService.USER_TZ;}

    ngOnInit() {
        this.getStatusList();
        this.getPriorityList();
        this.getCaseSourceList();
        this.getDealerList();
        this.getCaseTypeList();
        this.getcaseCategoryList();
        this.getAssignToList();
        this.getMakeList();
        //To make default value for dropdowns
        if (this.casesForm.typeId == null) {
            this.casesForm.typeId = {id: null, code: "", description: "", active: true};
        }
        if (this.casesForm.statusId == null) {
            this.casesForm.statusId = {id: null, code: "", description: "", active: true};
        }
        if (this.casesForm.priorityId == null) {
            this.casesForm.priorityId = {id: null, code: "", description: "", active: true};
        }
        if (this.casesForm.categoryId == null) {
            this.casesForm.categoryId = {id: null, code: "", description: "", active: true};
        }
        if (this.casesForm.dealerId == null) {
            this.casesForm.dealerId = {id: null, superDealerCode: "", name: "", globalCode: "", localCode: "", regionCode: "", countryCode: ""};
        }
        if (this.casesForm.sourceId == null) {
            this.casesForm.sourceId = {id: null, code: '', description: '', active: ''};
        }
        if (this.casesForm.vehicleType == null) {
            this.casesForm.vehicleType = {id: null, make: "", model: ""};
        }
        if (this.casesForm.assignedTo.id == null) {
            this.casesForm.assignedTo.id = null
        }

        this.activeroute.params.subscribe(params => {
            if (Object.keys(params).length != 0) {
                this.caseno = params.id;
                this.getCaseDetails();
                this.casesForm.id = this.caseno;
                this.caseheadername = "EDIT CASE";
                this.showOwnerSearch = true
            } else {
                this.noData = false;
                //this.fileInput.nativeElement.click();
            }
        }
        );
    }
    /**
    * @author Pradeep
    * @description get owners list based on search
    */
    getOwnersList() {
        this.noData = false;
        this.advanceOwnerSearchfields.userId = Number(this.userId);

        if (this.advanceOwnerSearchfields.lastName.replace(/ /g, "").length > 0 || this.advanceOwnerSearchfields.vin.replace(/ /g, "").length > 0) {
            this._caseService.getSearchOwnerList(this.advanceOwnerSearchfields, (result) => {

                this.isSearchSubmit = true;
                this.Ownersdata = result.beans;
                if (this.Ownersdata == '') {
                    this.noData = true;
                }
            })
        }
        else {
            this.Ownersdata = '';
            this.noData = true;
        }
    }
    /**
    * @author Pradeep
    * @description get owners data based on user select from owners list
    */
    getOwnerDetailsByName(id, vin, ownerVehicleId) {
        this._ownerService.viewOwnerDetails(vin, id, this.userId,ownerVehicleId, (result) => {
            this.casesForm.individualId = result;
            this.fileInputClose.nativeElement.click();
            if (result.vehicles.length > 0) {
                if (result.vehicles[0].vehicleType != null) {
                    this.make = result.vehicles[0].vehicleType.make
                }
            }
        })
    }

    /**
    * @author Pradeep
    * @description get status list
    */
    getStatusList() {
        this._caseService.getStatusList(this.userId, (result) => {
            this.statusList = result;
        });
    }
    /**
     * @author Pradeep
     * @description get priority list
     */
    getPriorityList() {
        this._caseService.getPriorityList(this.userId, (result) => {
            this.priorityList = result;
        });
    }
    /**
     * @author Pradeep
     * @description case source list
     */
    getCaseSourceList() {
        this._caseService.getCaseSourceList(this.userId, (result) => {
            this.caseSourceList = result;
        });
    }

    /**
     * @author Pradeep
     * @description case dealer list
     */
    getDealerList() {
        this._caseService.getDealerList(this.userId, (result) => {
          let sortedDealerList=result.sort((a, b) => a.globalCode - b.globalCode);
          this.dealerList = sortedDealerList;
        });
    }

    /**
     * @author Pradeep
     * @description case type list
     */
    getCaseTypeList() {
        this._caseService.getCaseTypeList(this.userId, (result) => {
            this.caseTypeList = result;
        });
    }

    /**
     * @author Pradeep
     * @description get assign user list
     */
    getAssignToList() {
        this._caseService.getAssignToList(this.userId, (result) => {
          result.sort(function(a,b){
            if ( a.fullName < b.fullName ){
              return -1;
            }
            if ( a.fullName > b.fullName ){
              return 1;
            }
            return 0;
          });
            this.assignToList = result;
        });
    }
    /**
     * @author Pradeep
     * @description get case Category List
     */
    getcaseCategoryList() {
        this._caseService.getcaseCategoryList(this.userId, (result) => {
            this.categoryList = result;
        });
    }
    /**
     * @author Pradeep
     * @description get case Sub Category List
     */
    getcaseSubCategoryList(e, type) {
        if (type == null) {
            var categoryId = e.target.value;
            this.casesForm.subCategory1Id.id = null
        }
        else
            var categoryId = e;
        this.subcategoryList = [];
        this.subcategory2List = [];
        this._caseService.getcaseSubCategoryList(categoryId, (result) => {
            this.subcategoryList = result;
        });
    }

    /**
     * @author Pradeep
     * @description get case Sub Category 2 List
     */
    getcaseSubCategory2List(e, type) {
        if (type == null) {
            var subcategoryId1 = e.target.value;
            this.casesForm.subCategory2Id.id = null
        }
        else
            var subcategoryId1 = e;
        this._caseService.getcaseSubCategory2List(subcategoryId1, (result) => {
            this.subcategory2List = result;
        });
    }

    /**
    * @author Pradeep
    * @description get make list
    */
    getMakeList() {
        this._caseService.getMakeList(this.userId, (result) => {
            this.makeList = result;
        });
    }

    /**
    * @author Pradeep
    * @params CaseId,userId
    * @description get the lead data
    */
    getCaseDetails() {
        this._caseService.viewCaseDetails(this.caseno, this.userId, (result) => {
            this.categoryId = result.categoryId.id;
            this.casesForm = result;
            //console.log(JSON.stringify(result))
            if (result.assignedTo == null) {
                this.casesForm.assignedTo = {id: null, userName: "", firstName: "", lastName: ""}
            }
            if (result.individualId.assignedTo == null) {
                this.casesForm.individualId.assignedTo = {id: null, userName: "", firstName: "", lastName: ""}
            }
            if (this.casesForm.typeId == null) {
                this.casesForm.typeId = {id: null, code: "", description: "", active: true};
            }
            if (this.casesForm.statusId == null) {
                this.casesForm.statusId = {id: null, code: "", description: "", active: true};
            }
            //            if (this.casesForm.sourceId == null) {
            //                this.casesForm.sourceId = {id: null, code: "", description: "", active: true};
            //            }
            if (this.casesForm.priorityId == null) {
                this.casesForm.priorityId = {id: null, code: "", description: "", active: true};
            }
            if (this.casesForm.categoryId == null) {
                this.casesForm.categoryId = {id: null, code: "", description: "", active: true};
            }
            if (this.casesForm.dealerId == null) {
                this.casesForm.dealerId = {id: null, superDealerCode: "", name: "", globalCode: "", localCode: "", regionCode: "", countryCode: ""};
            }
            if (result.subCategory1Id == null) {
                this.casesForm.subCategory1Id = {id: null, code: "", description: "", active: true};
            }
            if (result.subCategory2Id == null) {
                this.casesForm.subCategory2Id = {id: null, code: "", description: "", active: true};
            }
            if (this.casesForm.sourceId == null) {
                this.casesForm.sourceId = {id: null, code: '', description: '', active: ''};
            }
            if (this.casesForm.vehicleType == null) {
                this.casesForm.vehicleType = {id: null, make: "", model: ""};
            }
            this.subcategory1Id = this.casesForm.subCategory1Id.id;
            this.getcaseSubCategoryList(this.categoryId, 1);
            this.getcaseSubCategory2List(this.subcategory1Id, 1);
        })

    }
    /**
    * @author Pradeep
    * @params caseForm
    * @description save the case data
    */

    saveCase() {
        this.casesForm.userId = this.userId;
        this.casesForm.individualId.userId = this.userId;
        if (this.casesForm.vehicleType == null) {
            this.casesForm.vehicleType = {id: null, make: "", model: ""};
        }
        this._caseService.saveCase(this.casesForm, (result) => {
            if (result.statusCodes == "CASE_SAVED_SUCCESSFULLY") {
                this.caseno = result.id;
                if (this.caseno != "" && this.caseno != undefined) {
                    this._router.navigate(['cases/detail/' + this.caseno]);
                } else {
                    this._router.navigate(['cases']);
                }
            } else {
                this.errorMessage = "Something went wrong. Please try again !!";
                this._router.navigate(['cases/create']);
            }
        });
    }

    /**
    * @author Sowmya
    * @description cancel create or edit
    */
    cancel() {
        if (this.caseno != "" && this.caseno != undefined) {
            this._router.navigate(['cases/detail/' + this.caseno]);
        } else {
            this._router.navigate(['cases']);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/cases/components/case-crud.component.ts